module.exports = __webpack_public_path__ + "static/sample_takeaways-d4af271dd04be43c60ba2a05d53bbae4.png";